/*
=========================================================
NUPEP Money Utilities
Version 1.0.0
=========================================================
*/

window.NUPEP = window.NUPEP || {};

NUPEP.Money = {
  currency: "GBP",

  locale: "en-GB",

  format(cents) {
    return new Intl.NumberFormat(
      this.locale,

      {
        style: "currency",

        currency: this.currency,
      },
    ).format(cents / 100);
  },
};
